/**
 * Catégories du blog. `id` est utilisé dans les articles, `slug` dans les URLs.
 * Les couleurs proviennent de la palette Tailwind du site (src/tailwind.config.js).
 */
const categories = [
  {
    id: "ia",
    slug: "intelligence-artificielle",
    label: "Intelligence artificielle",
    short: "IA",
    description: "Modèles, usages, outils et retours d'expérience autour de l'IA, vus depuis Besançon.",
    color: "#6415FF", // primary-500
  },
  {
    id: "startups",
    slug: "startups-entreprises",
    label: "Startups & entreprises",
    short: "Startups",
    description: "Les entreprises, startups et industriels qui innovent dans le bassin bisontin.",
    color: "#ed64a6", // pink-500
  },
  {
    id: "recherche",
    slug: "recherche-universites",
    label: "Recherche & universités",
    short: "Recherche",
    description: "Laboratoires, université, écoles d'ingénieurs : la science qui prépare la tech de demain.",
    color: "#38b2ac", // teal-500
  },
  {
    id: "evenements",
    slug: "evenements",
    label: "Événements",
    short: "Événements",
    description: "Salons, meetups, conférences et rendez-vous tech à ne pas manquer à Besançon.",
    color: "#ed8936", // orange-500
  },
  {
    id: "formation",
    slug: "formation-emploi",
    label: "Formation & emploi",
    short: "Formation",
    description: "Se former à l'IA et au numérique, trouver une alternance ou un emploi dans la région.",
    color: "#48bb78", // green-500
  },
  {
    id: "collectivites",
    slug: "collectivites-territoire",
    label: "Collectivités & territoire",
    short: "Territoire",
    description: "Ville, métropole, services publics : le numérique au service du territoire.",
    color: "#4299e1", // blue-500
  },
];

export default categories;

const byId = Object.fromEntries(categories.map(c => [c.id, c]));
const bySlug = Object.fromEntries(categories.map(c => [c.slug, c]));

export const getCategory = id => byId[id] || null;
export const getCategoryBySlug = slug => bySlug[slug] || null;
